import _ from 'underscore'
import Backbone from 'backbone'
import TextTemplate from '../templates/text.tpl'

const SchoolNameView = Backbone.View.extend({
    initialize() {
        this.template = _.template(TextTemplate)
        this.listenTo(this.model, 'change', this.render)
    },
    render() {
        this.$el.html(this.template({text: this.model.get('name')}))
        return this
    }
})

export default SchoolNameView
